var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAngle = function SvgAngle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 28,
    fill: "none",
    viewBox: "0 0 30 28"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_8587_13060)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_linear_8587_13060)",
    d: "M13.268 22.535c.77 1.334 2.694 1.334 3.464 0l8.536-14.784c.77-1.334-.192-3-1.732-3H6.464c-1.54 0-2.502 1.666-1.732 3z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#paint1_linear_8587_13060)",
    strokeWidth: 4,
    d: "M18.464 23.535c-1.54 2.667-5.388 2.667-6.928 0L3 8.751c-1.54-2.667.385-6 3.464-6h17.072c3.08 0 5.004 3.333 3.464 6z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8587_13060",
    x1: 14.128,
    x2: -4.988,
    y1: -22.269,
    y2: -18.533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCE64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.235,
    stopColor: "#FFD48E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.655,
    stopColor: "#FFD48E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCE64"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8587_13060",
    x1: 15.698,
    x2: 15.698,
    y1: -8.344,
    y2: 54.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B271E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D5F40"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_8587_13060",
    width: 29.09,
    height: 26.785,
    x: 0.455,
    y: 0.75,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 0.996078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_8587_13060"
  })))));
};
export default SvgAngle;